import { z } from "zod";

/** Базовые правила валидации (ТЗ 10 §9). Используются и в API (DTO), и в формах ERP. */
export const trimmed = (min = 1, max = 255) => z.string().trim().min(min, { error: min === 1 ? "Обязательное поле" : `Минимум ${min} символов` }).max(max, { error: `Максимум ${max} символов` });

export const uuid = z.uuid({ error: "Некорректный идентификатор" });
export const phone = z
  .string()
  .trim()
  .transform((v) => v.replace(/[\s()-]/g, ""))
  .pipe(z.string().regex(/^\+[1-9]\d{7,14}$/, { error: "Телефон в формате +996XXXXXXXXX" }));
export const email = z.string().trim().toLowerCase().pipe(z.email({ error: "Некорректный email" }).max(254));
export const slug = z.string().trim().toLowerCase().max(120).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, { error: "Только латиница, цифры и дефис" });
export const pin = z.string().regex(/^\d{4,6}$/, { error: "PIN — 4–6 цифр" });
export const password = z
  .string()
  .min(10, { error: "Пароль — минимум 10 символов" })
  .max(128, { error: "Пароль — максимум 128 символов" })
  .refine((v) => /[A-Za-zА-Яа-я]/.test(v) && /\d/.test(v), { error: "Пароль должен содержать буквы и цифры" });
export const currency = z.string().regex(/^[A-Z]{3}$/, { error: "Код валюты ISO 4217" });
export const country = z.string().regex(/^[A-Z]{2}$/, { error: "Код страны ISO 3166-1" });
/** Деньги — целое ≥ 0 в minor units, ≤ 10^13. */
export const money = z.number().int({ error: "Сумма должна быть целой (minor units)" }).min(0).max(1e13);
/** Количества — строка-decimal во избежание потери точности. */
export const decimal = z.string().regex(/^\d{1,14}(\.\d{1,4})?$/, { error: "Некорректное количество" });
export const timezone = z.string().refine(
  (tz) => {
    try {
      new Intl.DateTimeFormat("en", { timeZone: tz });
      return true;
    } catch {
      return false;
    }
  },
  { error: "Неизвестный часовой пояс" },
);
export const locale = z.enum(["ru", "ky", "en", "uz"]);

export const pageQuery = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(50),
  q: z.string().trim().max(100).optional(),
});
export type PageQuery = z.infer<typeof pageQuery>;
